import { SentimentWordConfig } from './types';

export const esSentimentWordConfig: SentimentWordConfig = {
    positiveWords: new Set([
        'activo',
        'alegre',
        'apoyo',
        'aprobado',
        'brillante',
        'bueno',
        'calma',
        'claro',
        'completo',
        'completado',
        'confianza',
        'crecimiento',
        'exito',
        'excelente',
        'estable',
        'feliz',
        'fuerte',
        'genial',
        'listo',
        'logro',
        'mejora',
        'mejorado',
        'optimista',
        'perfecto',
        'positivo',
        'progreso',
        'resuelto',
        'saludable',
        'seguro',
        'soporte',
        'suave',
        'tranquilo',
        'util',
        'valioso',
        'victoria',
        'agradable',
        'alegria',
        'amor',
        'animado',
        'avance',
        'celebrar',
        'confiado',
        'eficaz',
        'encantado',
        'energia',
        'esperanza',
        'favorable',
        'ganar',
        'ganado',
        'inspirador',
        'logrado',
        'maravilloso',
        'mejor',
        'motivado',
        'orgullo',
        'recompensa',
        'salud',
        'satisfecho',
        'triunfo',
        'victorioso',
        'afable',
        'alivio',
        'amable',
        'aplauso',
        'armonioso',
        'bienestar',
        'capaz',
        'comodidad',
        'consistente',
        'conveniente',
        'cuidado',
        'disfrute',
        'eficiente',
        'empuje',
        'entusiasta',
        'esperanzado',
        'establecido',
        'estupendo',
        'firme',
        'ganancia',
        'genialidad',
        'grato',
        'honesto',
        'impulso',
        'luminoso',
        'mejoria',
        'ordenado',
        'potente',
        'protegido',
        'radiante',
        'recuperado',
        'refuerzo',
        'respaldo',
        'salvado',
        'sereno',
        'sonrisa',
        'triunfante',
        'valiente',
        'vibrante',
        'vivaz',
    ]),
    negativeWords: new Set([
        'amenaza',
        'ansioso',
        'atrasado',
        'atraso',
        'bloqueado',
        'caida',
        'caos',
        'confuso',
        'crisis',
        'debil',
        'declive',
        'demora',
        'desastre',
        'dificil',
        'dolor',
        'error',
        'falla',
        'fallido',
        'frustrado',
        'grave',
        'inseguro',
        'lento',
        'malo',
        'odio',
        'peligro',
        'peor',
        'problema',
        'rechazado',
        'regresion',
        'riesgo',
        'riesgoso',
        'roto',
        'terrible',
        'triste',
        'urgente',
        'agotado',
        'alarma',
        'amenazante',
        'atascado',
        'caido',
        'colapso',
        'complicado',
        'danino',
        'decepcion',
        'deprimido',
        'doloroso',
        'duro',
        'enojado',
        'fallando',
        'fatal',
        'fragil',
        'horrible',
        'inquieto',
        'mal',
        'molesto',
        'panico',
        'pendiente',
        'perdida',
        'preocupacion',
        'rechazo',
        'tenso',
        'vulnerable',
        'vergonzoso',
        'presion',
        'torpe',
        'abrumado',
        'agresivo',
        'alarmante',
        'amargo',
        'apagado',
        'arduo',
        'arruinado',
        'asustado',
        'aterrador',
        'bloqueante',
        'danado',
        'defecto',
        'desorden',
        'doliente',
        'estres',
        'hostil',
        'hundido',
        'inestable',
        'inutil',
        'irritante',
        'lamentable',
        'obstaculo',
        'opresivo',
        'perjudicial',
        'presionado',
        'quiebre',
        'rojo',
        'sufrimiento',
        'tenso',
        'toxico',
        'trauma',
        'vulnerado',
        'verguenza',
        'critico',
        'pesado',
    ]),
};
